<template>
    <!-- List Contacts Page -->
    <div class="page-layout blank contacts-manage">
        <!-- <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallinprogress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div> -->
        <div class="pb-15 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span v-if="this.$route.params.module_type == 'contacts'" class="pointer" @click="BackToContactDashboard">Contact Dashboard</span>
                    <span v-else-if="this.$route.params.module_type == 'customers'" class="pointer" @click="BackToCustomerDashboard">Customers Dashboard</span>
                    <span v-else-if="this.$route.params.module_type == 'leads'" class="pointer">Lead Dashboard</span>
                    <span v-else>Tools</span>
                    <span @click="goBack"><router-link to="" class="text-white pl-2 text-line">Meeting List</router-link></span>
                    <a>View Meeting</a>
                </div>
                <div class="d-flex flex-wrap align-items-center media-margin-bottom dis-none" v-if="meeting_info">
                    <div class="dropdown">
                        <a class="btn btn-new-primary btn-wide dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Use Meeting info to create
                        </a>
                        <div class="dropdown-menu meeting-type-menu" aria-labelledby="dropdownMenuLink" style="width: 234px !important;border-radius: 8px !important;left: 24px !important;">
                            <a class="btn btn-new-primary btn-wide dropdown-toggle pl-4 fw-500" href="#" role="button" id="dropdownSubMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="background-color: #fff;color: #3C4252 !important;text-decoration: none !important;">
                                <img src="/static/images/callreport_meet.svg" alt="" class="pr-1">
                                Call Report
                            </a>
                            <div class="dropdown-menu meeting-type-menu meeting-sub-dropdown" aria-labelledby="dropdownSubMenuLink">
                                <a class="dropdown-item" v-on:click="createCallReport('External Meeting')">External Meeting</a>
                                <a class="dropdown-item" v-on:click="createCallReport('Internal Meeting')">Internal Meeting</a>
                                <a class="dropdown-item" v-on:click="createCallReport('Review Meeting')">Review Meeting</a>
                                <a class="dropdown-item" v-on:click="createCallReport('Sales Meeting')">Sales Meeting</a>
                            </div>
                            <a class="dropdown-item" @click="createMeeting('deal')"><img src="/static/images/deal_meet.svg" alt=""><span class="pl-2 fw-500">Deal</span></a>
                            <a class="dropdown-item" @click="createMeeting('follow_up')"><img src="/static/images/followup_meet.svg" alt=""><span class="pl-2 fw-500">Follow Up</span></a>
                            <a class="dropdown-item" @click="createMeeting('lead')"><img src="/static/images/lead_meet.svg" alt=""><span class="pl-2 fw-500">Lead</span></a>
                            <a class="dropdown-item" @click="createMeeting('customer')"><img src="/static/images/customer_meet.svg" alt=""> <span class="pl-2 fw-500">Customer</span></a>
                            <!-- <a class="dropdown-item"><img class="pl-1" src="/static/images/helpdesk_meet.svg" alt=""><span class="pl-3">Helpdesk Ticket</span></a> -->
                        </div>
                    </div>
                    <!-- <button class="btn btn-new-primary btn-wide px-6 mr-4 margin767 margin483">Use Meeting info to create </button> -->
                </div>
            </div>
            <div class="d-flex justify-content-between mt-3">
                <!-- Tabs Section -->
                <div class="tabs tabs-style-shape">
                    <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                        <defs>
                            <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                        </defs>
                    </svg>
                    <nav>
                        <ul class="ml-0">
                            <li :class="{'tab-current':active_tab == 'meeting_info'}">
                                <a href="javascript:;" @click="switchTabs('meeting_info')" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span>Meeting Info</span>
                                </a>
                            </li>
                            <li :class="{'tab-current':active_tab == 'call_report'}">
                                <a href="javascript:;" @click="switchTabs('call_report')" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span style="border-radius: 30px 0 0 0;">Call Report</span>
                                </a>
                            </li>
                            <li :class="{'tab-current':active_tab == 'follow_up'}">
                                <a href="javascript:;" @click="switchTabs('follow_up')" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span style="border-radius: 30px 0 0 0;">Follow Ups</span>
                                </a>
                            </li>
                            <!-- <li :class="{'tab-current':active_tab == 'help_desk'}">
                                <a href="javascript:;" @click="switchTabs('help_desk')" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span style="border-radius: 30px 0 0 0;">helpdesk Ticket</span>
                                </a>
                            </li> -->
                            <!-- For styling we need this tag  -->
                            <li style="width: 0px !important;flex: 0 !important;">
                                <a href="#section-shape-3" style="margin: 0">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <meeting-info-tab v-if="meeting_info" :active_status="active_tab == 'meeting_info'"></meeting-info-tab>
            <call-report-tab v-if="call_report" :active_status="active_tab == 'call_report'"></call-report-tab>
            <follow-up-tab v-if="follow_up" :active_status="active_tab == 'follow_up'"></follow-up-tab>
            <help-desk-tab v-if="help_desk" :active_status="active_tab == 'help_desk'"></help-desk-tab>
            <create-reminder v-if="createReminderShow" :lead_edit_stage="lead_edit_stage" :lead_current_stage="lead_current_stage" :from_module="from_module" :meeting_type="meeting_type" :mode_id="mode_id" :recurring_id="recurring_id" :view_mode="view_mode" modal_name="createReminder" @hideCreateReminder="hideCreateReminder" @hideCreateReminderSave="hideCreateReminderSave"></create-reminder>
        </div>
    </div>
</template>
<script>
const CreateReminder = () => import("../Reminders/CreateReminder.vue");
import { EventBus } from '../eventBus/nav-bar-event';
import MeetingInfoTab from "./MeetingInfoTab"
import CallReportTab from "./CallReportTab"
import FollowUpTab from "./FollowUpTab"
import HelpDeskTab from "./HelpDeskTab"
    export default {
        mixins: [],
        components: {MeetingInfoTab, CallReportTab, FollowUpTab, HelpDeskTab, CreateReminder},
        data() {
            return {
                active_tab: 'meeting_info',
                meeting_info: true,
                call_report: false,
                follow_up: false,
                help_desk: false,
                createReminderShow: false,
                mode_id: '',
                recurring_id: '',
                view_mode: 'create',
                meeting_id: "",
                from_module: "",
                meeting_type: "",
                lead_edit_stage: "",
                lead_current_stage: ""
            }
        },
        methods:{
            goBack(){
                this.$router.go(-1);
            },
            BackToContactDashboard(){
                this.$router.push('/Contacts/IndividualContact_Dashboard/' + this.$route.params.module_id);
            },
            BackToCustomerDashboard(){
                this.$router.push('/Customers/IndividualCustomer_Dashboard/' + this.$route.params.module_id);
            },
            BackToLeadDashboard(){
                this.$router.push(`/leads/LeadProfile_Dashboard/` + this.$route.params.id);
            },
            createCallReport(category) {
                this.meeting_id = this.$route.params.id
                this.$store.commit("setCallReportCategory", category);
                localStorage.setItem('meeting_id', JSON.stringify(this.meeting_id))
                if(this.$route.params.module_type == 'contacts' || this.$route.params.module_type == 'customers' || this.$route.params.module_type == 'leads' ){
                    this.$router.push('/callreports/new/'+this.$route.params.module_type+'/'+this.$route.params.module_id);
                }else{
                    this.$router.push('/callreport/new')
                }
            },
            hideCreateReminderSave(){
                this.createReminderShow = false;
                this.mode_id = ''
                this.recurring_id = ''
                this.view_mode = 'create'
            },
            hideCreateReminder(){
                this.createReminderShow = false;
            },
            createMeeting(type){
                if(type == 'customer'){
                    this.$router.push({
                        name: "CreateCustomer",
                        params:{
                            id: "new"
                        }
                    })
                }else if(type == 'deal'){
                    this.meeting_id = this.$route.params.id
                    localStorage.setItem('meeting_id', JSON.stringify(this.meeting_id))
                    this.$router.push({
                        name: "CreateDealsNew",
                        params:{
                            id: "new"
                        }
                    })
                }else if(type == 'follow_up'){
                    if(this.$route.params.module_type == 'contacts'){
                        this.from_module = 'contact'
                        this.recurring_id = this.$route.params.id
                    }else if(this.$route.params.module_type == 'customers'){
                        this.from_module = 'customer'
                        this.recurring_id = this.$route.params.id
                    }else if(this.$route.params.module_type == 'leads'){
                        this.from_module = 'leads'
                        this.recurring_id = this.$route.params.id
                    }else{
                        this.from_module = 'tools'
                        this.recurring_id = this.$route.params.id
                    }
                    this.meeting_type = "meeting"
                    // this.from_module = ''
                    this.mode_id = this.$route.params.module_id
                    // this.recurring_id = ''
                    this.view_mode = 'create'
                    this.createReminderShow = true;
                    setTimeout(() => {
                        this.$modal.show("createReminder")
                    }, 500);
                }else if(type == 'lead'){
                    this.$router.push({
                        path: "/leads/createLeads/individual/new",
                    })
                }
            },
            switchTabs(type){
                if(type == 'meeting_info'){
                    this.active_tab = 'meeting_info'
                    this.meeting_info = true
                    this.call_report = false
                    this.follow_up = false
                    this.help_desk = false
                } else if(type == 'call_report') {
                    this.active_tab = 'call_report'
                    this.meeting_info = false
                    this.call_report = true
                    this.follow_up = false
                    this.help_desk = false
                } else if(type == 'follow_up') {
                    this.active_tab = 'follow_up'
                    this.meeting_info = false
                    this.call_report = false
                    this.follow_up = true
                    this.help_desk = false
                } else if(type == 'help_desk') {
                    this.active_tab = 'help_desk'
                    this.meeting_info = false
                    this.call_report = false
                    this.follow_up = false
                    this.help_desk = true
                }
            }
        },
        mounted(){
            this.lead_current_stage = this.$route.params.stage_name
            this.lead_edit_stage = this.$route.params.stage_name
        }
    }
</script>
<style>
    .dropdown-menu.meeting-type-menu{
        transform: translate3d(-22px, 36px, 0px) !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/ScheduleMeeting/ScheduleMeetingViewDetails.vue